import { getJumpPath } from "./jump";
// import { isMobile, isTablet } from './device'
import { globalRem } from "./rem";
import { getParams, detectIEEdge, getDomainName } from "./utils";
import token from "./token";

const utils = {
  getJumpPath,
  // isMobile,
  // isTablet,
  globalRem,
  token,
  getParams,
  detectIEEdge,
  getDomainName,
};

export default utils;
